import { createContext } from "react";

export const IsMobileContext = createContext(true);
export const SelectedProjectContext = createContext({});
export const ProjectsContext = createContext([]);
export const UserInfoContext = createContext({});
export const ChartInsightsContext = createContext([]);
export const ChartRangeContext = createContext(0);
